import React from "react";
import { useLocation, Link } from "react-router-dom";

export default function PaymentFailed() {
  const query = new URLSearchParams(useLocation().search);
  const message = query.get("msg") || "Payment Failed ❌";

  return (
    <div className="min-h-screen flex items-center justify-center bg-red-50">
      <div className="bg-white shadow-lg rounded-2xl p-8 max-w-md text-center">
        <div className="mb-4 p-3 rounded bg-red-100 text-red-700">
          {message}
        </div>
        <h2 className="text-2xl font-bold">Oops!</h2>
        <p className="text-gray-600 mt-2">
          Something went wrong. Please try again later.
        </p>
        <Link
          to="/members"
          className="mt-6 inline-block px-6 py-2 bg-red-600 text-white rounded-lg shadow hover:bg-red-700"
        >
          Go to Homepage
        </Link>
      </div>
    </div>
  );
}
